import React from 'react';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const Hero = () => {
  return (
    <section id="hero" className="min-h-screen relative overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0" style={{ background: '#F5EBDD' }}></div>

      <div className="flex items-center justify-center min-h-screen relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          
          {/* Left Side: Text Content */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6 text-center lg:text-center lg:mt-0"
          >
            {/* Alera Brand */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1, delay: 0.2 }}
              className="mb-0"
            >
              <img 
                src="/images/Aleracurrent_charcoaltrans.png" 
                alt="Alera" 
                className="w-auto h-64 sm:h-72 md:h-80 lg:max-h-[500px] mx-auto mt-2 mb-16 md:mt-0 md:mb-0"
              />
              <div
                className="w-40 h-1 mx-auto rounded-full -mt-12"
                style={{ background: 'linear-gradient(90deg, #d9a79c 0%, rgba(201,163,130,0.8) 50%, #d9a79c 100%)' }}
              ></div>
            </motion.div>

            {/* Tagline */}
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="text-xl md:text-2xl text-charcoal-600 max-w-3xl mx-auto leading-relaxed font-light font-nunito"
            >
              A safe and inspiring space for women to transform health struggles 
              into strength and confidence
            </motion.p>

            {/* Call to Action Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              className="flex flex-col sm:flex-row gap-6 justify-center items-center"
            >
              <RouterLink to="/about">
                <motion.button
                  whileHover={{ scale: 1.02, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  style={{ backgroundColor: '#d9a79c' }}
                  className="text-white px-10 py-4 rounded-2xl text-lg font-medium hover:opacity-90 transition-all duration-300 shadow-soft hover:shadow-soft-lg"
                >
                  My Story
                </motion.button>
              </RouterLink>
              
              <RouterLink to="/login">
                <motion.button
                  whileHover={{ scale: 1.02, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  style={{ borderColor: '#d9a79c', color: '#d9a79c' }}
                  className="border-2 px-10 py-4 rounded-2xl text-lg font-medium hover:text-white transition-all duration-300"
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#d9a79c'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  Member Login
                </motion.button>
              </RouterLink>
            </motion.div>

            {/* Small Community Link */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 1.2 }}
              className="mt-8"
            >
              <RouterLink to="/signup">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  style={{ color: '#d9a79c' }}
                  className="text-sm font-medium transition-all duration-200 hover:opacity-80"
                >
                  Join the Community →
                </motion.button>
              </RouterLink>
            </motion.div>
          </motion.div>

          {/* Right Side: Photo */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="hidden lg:block lg:mt-16"
          >
            <div className="relative flex items-center justify-center">
              <img 
                src="/images/kate-hero.jpg" 
                alt="Alera wellness lifestyle" 
                loading="eager"
                className="w-full max-h-[500px] object-cover rounded-3xl shadow-soft-lg"
              />
            </div>
          </motion.div>

        </div>
      </div>
      
    </section>
  );
};

export default Hero;
